import { Pipe, PipeTransform } from '@angular/core';
import { ApiUserHelperService } from './user-helper.service';
import { ucFirst } from '../helpers/function/uc-first';

@Pipe({
  name: 'apiUser',
})
export class ApiUserHelperPipe implements PipeTransform {
  constructor(private _apiUserHelperSrv: ApiUserHelperService) {}

  transform(railGuard: any, ...args: any[]): any {
    const [fct] = args;
    args.shift();
    return (this._apiUserHelperSrv as any)['get' + ucFirst(fct)](
      railGuard,
      ...args
    );
  }
}

@Pipe({
  name: 'apiUserU',
  pure: false,
})
export class ApiUserHelperUnpurePipe
  extends ApiUserHelperPipe
  implements PipeTransform {}
